import cn from 'classnames'
import {FC, ReactNode} from 'react'

import {theme} from '@/theme/theme'
import {MOBILE_SCREENSIZE} from '@/utils/styles/breakpoints'

import {Text, TextVariant} from '../common/content/Text'

type HeaderNavigationLabelProps = {
  label: string
  badge?: ReactNode
  visibleOnMobile?: boolean
}

export const HeaderNavigationLabel: FC<HeaderNavigationLabelProps> = ({
  label,
  badge,
  visibleOnMobile = false,
}) => (
  <>
    <div className={cn('label-wrapper', visibleOnMobile && 'mobile')}>
      <Text variant={TextVariant.text14} className="truncated" color={theme.palette.text.white}>
        {label}
      </Text>
      {badge && <div className="badge">{badge}</div>}
    </div>

    <style jsx>{`
      .label-wrapper {
        display: flex;
        align-items: center;
      }
      .label-wrapper::before {
        content: '/';
        color: ${theme.palette.text.white};
        ${theme.typography.text14.desktop};
        margin-left: ${theme.spacing[2.5]};
        margin-right: ${theme.spacing[2]};
      }
      .badge {
        white-space: nowrap;
        margin-left: ${theme.spacing[2]};
      }
      @media ${MOBILE_SCREENSIZE} {
        .label-wrapper:not(.mobile) {
          display: none;
        }
        .label-wrapper.mobile {
          margin-left: ${theme.spacing[2]};
        }
        .label-wrapper.mobile::before {
          display: none;
        }
      }
    `}</style>
  </>
)
